import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case02.technical-process-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  signalFlowMenu1: {
    id: `${PREFIX}.signal-flow-menu.1`,
  },
  signalFlowMenu2: {
    id: `${PREFIX}.signal-flow-menu.2`,
  },
});
